// extracted by mini-css-extract-plugin
export default {"vipBenefits":"vipBenefits_vipBenefits__nJtOH","upgrade_title":"vipBenefits_upgrade_title__pk6Xq","tip":"vipBenefits_tip__CZ3Sj"};